export const defaultServerSideParams = {
  limit: 50,
  offset: 0,
};

export const columnPivotOptions = {
  filter: 'agSetColumnFilter',
  editable: true,
  enablePivot: true,
  enableRowGroup: true,
  aggFunc: 'sum',
};

export const gridPivotOptions = {
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: '',
  },
  pivotPanelShow: 'always',
  rowGroupPanelShow: 'always',
  enableRangeSelection: true,
  enableCharts: true,
  groupTotalRow: true,
  autoGroupColumnDef: {
    minWidth: 100,
    lockPosition: 'left',
    cellRendererParams: {
      suppressCount: true,
    },
  },
  suppressAggFuncInHeader: true,
};

export enum CustomReportTypes {
  REPORT = 'Report',
  REPORT_SET = 'Report Set',
}

export enum CustomReportParamTypes {
  input = 'input',
  query = 'query',
  validator = 'validator'
}
